<template>
  <Splide
    v-if="images?.length > 1"
    ref="splideRef"
    :options="splideOptions"
    aria-label="Gallery of images"
  >
    <SplideSlide
      v-for="(item, index) in images"
      :key="index"
      class="splide__slide"
    >
      <img
        v-if="item.original_url"
        :src="item.original_url"
        :alt="`Image ${index + 1}`"
        class="slide__img"
        loading="lazy"
      />
    </SplideSlide>
  </Splide>

  <img
    v-else
    :src="images[0]?.original_url"
    alt="Image 1"
    class="slide__img"
    loading="lazy"
  />
</template>

<script lang="ts" setup>
  import type { Images } from "~/lib/types";

  const Splide = defineAsyncComponent(() =>
    import("@splidejs/vue-splide").then((m) => m.Splide)
  );

  const SplideSlide = defineAsyncComponent(() =>
    import("@splidejs/vue-splide").then((m) => m.SplideSlide)
  );

  interface Props {
    images: Images[];
  }

  const props = defineProps<Props>();

  const splideOptions = {
    type: "loop",
    pagination: false,
    arrows: true,
    speed: 500,
  };
</script>

<style lang="scss">
  img {
    width: 100%;
    height: 100%;
    max-height: 671px;
    object-fit: cover;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    display: block;
  }

  // Hide arrows by default
  .splide__arrow {
    opacity: 1 !important;
    transition: opacity 0.5s ease-in-out;
    width: 40px !important;
    height: 40px !important;
    background: white !important;

    &--prev {
      left: 1rem;
    }

    &--next {
      right: 1rem;
    }

    svg {
      fill: #333;
      width: 1rem;
      height: 1rem;
    }

    @media (min-width: 1024px) {
      opacity: 0 !important;
    }
  }

  // Show arrows only when hovering over the slide area
  .splide:hover .splide__arrow {
    opacity: 1 !important;
  }
</style>
